function enableDragScroll(target, options = {}) {
  if (!target) return;
  if (options.snapSelector) return enableCardSnapScroll(target, options.snapSelector);

  let animationId = 0;
  let isDragging = false;
  let velocity = 0;
  let lastTime = 0;
  let startX = 0;

  target.addEventListener('mousedown', startDrag)

  function startDrag(e) {
    // 保存X坐标值
    startX = e.clientX;

    lastTime = performance.now();
    cancelAnimationFrame(animationId);

    document.addEventListener('mousemove', drag);

    // 注：这里之所以监听click事件而非mouseup，是因为在mouseup事件中无法阻止click默认行为，如果拖拽行为发生在链接标签上，拖拽结束后会错误触发链接跳转。
    document.addEventListener('click', stopDrag, {
      passive: false,
      capture: true,
    });
  };

  function drag(e) {
    const movedX = Math.abs(e.clientX - startX);

    // 只有当移动距离超过阈值时才认为是拖拽
    if (movedX > 5) {
      isDragging = true;

      const now = performance.now();
      const deltaTime = now - lastTime;

      if (deltaTime > 0) {
        const deltaX = e.movementX;
        target.scrollLeft -= deltaX;
        velocity = (-deltaX / deltaTime) * 1000; // pixels per second
        lastTime = now;
      }
    }
  }

  function stopDrag(e) {
    if (isDragging) {
      isDragging = false;
      e.stopPropagation();
      e.preventDefault();

      // 惯性滚动效果
      if (Math.abs(velocity) > 10) {
        // Only apply inertia if velocity is significant
        applyInertia();
      }
    }

    document.removeEventListener('mousemove', drag);
    document.removeEventListener('click', stopDrag, true);
  }

  function applyInertia() {
    const friction = 0.95;
    const minVelocity = 0.5;

    const animate = () => {
      if (Math.abs(velocity) < minVelocity) {
        velocity = 0;
        return;
      }

      velocity *= friction;
      target.scrollLeft += velocity / 60; // Divide by 60 to get movement per frame

      animationId = requestAnimationFrame(animate);
    };

    animationId = requestAnimationFrame(animate);
  }

  return function destroyDragScroll() {
    cancelAnimationFrame(animationId);
    document.removeEventListener('mousemove', drag);
    document.removeEventListener('click', stopDrag, true);
    target.removeEventListener('mousedown', startDrag);
  };
}

function enableCardSnapScroll(target, selector) {
  const direction = getComputedStyle(target).direction === 'rtl' ? -1 : 1;
  let animationId = 0;
  let gesture = null;
  let suppressClick = false;

  function animateTo(position) {
    cancelAnimationFrame(animationId);
    const start = target.scrollLeft;
    const end = position * direction;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      target.scrollLeft = end;
      return;
    }

    const startTime = performance.now();
    function animate(now) {
      const progress = Math.min((now - startTime) / 300, 1);
      target.scrollLeft = start + (end - start) * (1 - Math.pow(1 - progress, 3));
      if (progress < 1) animationId = requestAnimationFrame(animate);
    }
    animationId = requestAnimationFrame(animate);
  }

  function startDrag(event) {
    if (!event.isPrimary || event.button !== 0 || gesture) return;
    const cards = Array.from(target.querySelectorAll(selector));
    if (!cards.length) return;

    cancelAnimationFrame(animationId);
    const maxScroll = Math.max(0, target.scrollWidth - target.clientWidth);
    const firstLeft = cards[0].getBoundingClientRect().left;
    const positions = [...new Set(cards.map((card) => Math.max(0, Math.min(
      maxScroll, (card.getBoundingClientRect().left - firstLeft) * direction
    ))))];
    if (positions.length < 2) return;

    const scroll = target.scrollLeft * direction;
    const index = positions.reduce((closest, position, current) => (
      Math.abs(position - scroll) < Math.abs(positions[closest] - scroll) ? current : closest
    ), 0);
    gesture = { pointerId: event.pointerId, startX: event.clientX, scroll, positions, index, delta: 0 };
    suppressClick = false;
    target.setPointerCapture(event.pointerId);
  }

  function drag(event) {
    if (!gesture || event.pointerId !== gesture.pointerId) return;
    gesture.delta = (gesture.startX - event.clientX) * direction;
    if (Math.abs(gesture.delta) <= 5 && !suppressClick) return;

    suppressClick = true;
    if (event.cancelable) event.preventDefault();
    const { positions, index, scroll, delta } = gesture;
    const min = positions[Math.max(0, index - 1)];
    const max = positions[Math.min(positions.length - 1, index + 1)];
    target.scrollLeft = Math.max(min, Math.min(max, scroll + delta)) * direction;
  }

  function stopDrag(event) {
    if (!gesture || event.pointerId !== gesture.pointerId) return;
    const { pointerId, positions, index, delta } = gesture;
    gesture = null;
    const step = event.type === 'pointerup' && Math.abs(delta) >= 24 ? Math.sign(delta) : 0;
    animateTo(positions[Math.max(0, Math.min(positions.length - 1, index + step))]);
    if (target.hasPointerCapture(pointerId)) target.releasePointerCapture(pointerId);
  }

  function preventDragClick(event) {
    if (!suppressClick) return;
    suppressClick = false;
    event.preventDefault();
    event.stopPropagation();
  }

  target.addEventListener('pointerdown', startDrag);
  target.addEventListener('pointermove', drag, { passive: false });
  target.addEventListener('pointerup', stopDrag);
  target.addEventListener('pointercancel', stopDrag);
  target.addEventListener('lostpointercapture', stopDrag);
  target.addEventListener('click', preventDragClick, true);

  return function destroyCardSnapScroll() {
    cancelAnimationFrame(animationId);
    const pointerId = gesture?.pointerId;
    gesture = null;
    if (pointerId !== undefined && target.hasPointerCapture(pointerId)) target.releasePointerCapture(pointerId);
    target.removeEventListener('pointerdown', startDrag);
    target.removeEventListener('pointermove', drag);
    target.removeEventListener('pointerup', stopDrag);
    target.removeEventListener('pointercancel', stopDrag);
    target.removeEventListener('lostpointercapture', stopDrag);
    target.removeEventListener('click', preventDragClick, true);
  };
}
